import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { globalHotkeyDefinitions, getDisplayKey } from '@/app/config/hotkeys'

interface HotkeysHelpProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const HotkeysHelp: React.FC<HotkeysHelpProps> = ({ open, onOpenChange }) => {
  const isMac = navigator.platform.toLowerCase().includes('mac')

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
          <DialogDescription>
            Quick access to common actions. Press Alt+H at any time to see this help.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-2 mt-4">
          {Object.entries(globalHotkeyDefinitions).map(([key, definition]) => (
            <div
              key={key}
              className="flex items-center justify-between py-2 px-3 rounded-md hover:bg-muted"
            >
              <span className="text-sm">{definition.description}</span>
              <kbd className="px-2 py-1 text-xs bg-muted rounded-md font-mono">
                {getDisplayKey(definition.keys)}
              </kbd>
            </div>
          ))}
        </div>
        <div className="mt-4 text-xs text-muted-foreground">
          {isMac ? 'Using Mac keyboard shortcuts' : 'Using Windows/Linux keyboard shortcuts'}
        </div>
      </DialogContent>
    </Dialog>
  )
}